/**
 * Price field for listing/bundle steppers: at most 4 digits before the decimal
 * and at most 2 digits after. Returns sanitized string, or null if input should be ignored.
 */
export const sanitizeStepperPriceInput = (input) => {
  if (input === "" || input == null) return "";

  let value = String(input).trim();
  if (value === "") return "";

  if (value.startsWith(".")) {
    value = `0${value}`;
  }

  if (!/^\d*\.?\d*$/.test(value)) {
    return null;
  }

  const dot = value.indexOf(".");
  const intPart = dot === -1 ? value : value.slice(0, dot);
  const fracPart = dot === -1 ? undefined : value.slice(dot + 1);

  if (/^0\d/.test(intPart)) {
    return null;
  }

  const intLimited = intPart.slice(0, 4);

  if (dot === -1) {
    return intLimited;
  }

  let out = `${intLimited}.`;
  if (fracPart !== undefined) {
    out += fracPart.slice(0, 2);
  }
  return out;
};

export const generateUUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      let r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    }
  );
};

/** Normalize API category fields (id | object | null) to a Select-friendly id. */
export const toCategoryId = (value) => {
  if (value == null || value === "") return "";
  if (typeof value === "object") {
    return value.id ?? value.pk ?? "";
  }
  return value;
};

/** Match a stored id to an option's typed id so MUI Select can display it. */
export const matchOptionId = (options, value) => {
  const id = toCategoryId(value);
  if (id === "" || !options?.length) return "";
  const match = options.find((option) => String(option.id) === String(id));
  return match ? match.id : id;
};

export const formatEditData = (editlistdata) => {
  // Transform tags if they're in string format
  let formattedTags = [];
  if (editlistdata.tags) {
    // Case 1: JSON string (from API)
    if (typeof editlistdata.tags === "string") {
      try {
        const parsedTags = JSON.parse(editlistdata.tags);
        formattedTags = Array.isArray(parsedTags)
          ? parsedTags.map((tag) =>
              typeof tag === "string" ? { name: tag } : tag
            )
          : [];
      } catch (error) {
        console.error("Error parsing tags JSON:", error);
        formattedTags = [{ name: editlistdata.tags }];
      }
    }
    // Case 2: Already an array
    else if (Array.isArray(editlistdata.tags)) {
      formattedTags = editlistdata.tags.map((tag) =>
        typeof tag === "string"
          ? { name: tag }
          : typeof tag === "object" && tag.name
          ? tag
          : { name: String(tag) }
      );
    }
  }

  // Handle canva data - parse it if it's a JSON string
  let canvaData = editlistdata.canva;
  if (typeof editlistdata.canva === "string") {
    try {
      canvaData = JSON.parse(editlistdata.canva);
    } catch (error) {
      console.error("Error parsing canva JSON:", error);
    }
  }

  return {
    ...editlistdata,
    tags: formattedTags,
    canva: canvaData,
    category: toCategoryId(editlistdata.category),
    subcategory: toCategoryId(editlistdata.subcategory),
    subsubcategory: toCategoryId(editlistdata.subsubcategory),
  };
};

